import { deleteApi, getApi, postApi } from "../../common/api";

export const getWishlist = (userId:any) => {
    return getApi('/api/users/' + userId + '/get-wishlist');
};

export const addWishlist =(data:any) =>{
    return postApi('/api/users/:id/add-wishlist',data);
}

export const removeWishlist = (id: any) => {
    return deleteApi("/api/users/:id/remove");
};

export const clearWishlist = () => {
    return deleteApi("/api/users/:id/clear");
};
